import React from "react";
import { HighChart } from "../Generic/Charts";

interface StackedBarProps {
  chartName: string;
  yAxisTitle: string;
  categoriesData: { name: string; fullname: string }[];
  data: number[];
}

const StackedBarChart: React.FC<StackedBarProps> = ({
  chartName,
  yAxisTitle,
  categoriesData,
  data,
}) => {
  const categoryNames = categoriesData.map((category) => category.name);

  const chartOptions = {
    chart: {
      type: "bar",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: categoryNames,
    },
    yAxis: {
      min: 0,
      title: {
        text: yAxisTitle,
      },
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
    },
    tooltip: {
      pointFormatter: function (
        this: Highcharts.TooltipFormatterContextObject
      ) {
        const categoryIndex = this.x as number;
        const categoryName = categoryNames[categoryIndex];
        const fullName = categoriesData.find(
          (category) => category.name === categoryName
        )?.fullname;

        return `<b>${chartName}</b><br>${fullName}`;
      },
    },
    series: [
      {
        name: chartName,
        data: data,
      },
    ],
  };

  return (
    <HighChart cardTitleLarge={chartName} colSize="12" options={chartOptions} />
  );
};

export default StackedBarChart;
